module.exports = __webpack_public_path__ + "common/icon-fullcolor-0e56bf4faef1c9022786d237c97d6859.svg";